import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShareandarrowup = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={20} height={26} fill='none' {...props}>
    <path
      fill='currentColor'
      d='M10.46 16.71c.463 0 .86-.386.86-.837V4.841l-.064-1.612.72.763 1.632 1.74c.15.172.366.258.58.258.44 0 .785-.322.785-.762 0-.226-.097-.398-.258-.559l-3.631-3.502c-.215-.215-.397-.29-.623-.29-.215 0-.398.075-.623.29L6.207 4.669a.75.75 0 0 0-.247.559c0 .44.322.762.773.762.205 0 .44-.086.591-.258l1.622-1.74.73-.763-.064 1.612v11.032c0 .451.387.838.849.838m-6.154 8.412h12.321c2.245 0 3.373-1.117 3.373-3.33v-10.72c0-2.214-1.128-3.33-3.373-3.33H13.63V9.47h2.965c1.063 0 1.675.58 1.675 1.697v10.527c0 1.117-.612 1.698-1.675 1.698H4.327c-1.074 0-1.665-.58-1.665-1.698V11.168c0-1.117.59-1.697 1.665-1.697h2.976V7.74H4.306c-2.245 0-3.373 1.117-3.373 3.33v10.721c0 2.213 1.128 3.33 3.373 3.33'
    />
  </svg>
);
export default SvgShareandarrowup;
